module.exports = __webpack_public_path__ + "static/media/energy2.f5f1d0d3.jpeg";